export const LearnMoreVariant = {
  Variant: {
    BelowPrice: 0,
    AbovePrice: 1,
    Default: 2,
  },
  getVariant(partner, treatments) {
    const Variant = LearnMoreVariant.Variant;
    const { results_bundle_learn_more_position } = treatments;

    const isPartner = !!partner;
    const isWowPartner = isPartner && partner === 'wow';
    const isActiveTreatment = results_bundle_learn_more_position?.treatment === 'on';

    if (isPartner) {
      return isWowPartner ? Variant.BelowPrice : Variant.Default;
    }

    if (isActiveTreatment) {
      return Variant.AbovePrice;
    }

    return Variant.Default;
  },
  isDefault: variant => variant === LearnMoreVariant.Variant.Default,
  isAbovePrice: variant => variant === LearnMoreVariant.Variant.AbovePrice,
  isBelowPrice: variant => variant === LearnMoreVariant.Variant.BelowPrice,
};

export const InternetOptionVariant = {
  Variant: {
    Below: 0,
    Default: 1,
  },
  getVariant(partner, treatments) {
    const Variant = InternetOptionVariant.Variant;
    const { results_internet_option_position } = treatments;

    const isPartner = !!partner;
    const isActiveTreatment = results_internet_option_position?.treatment === 'on';

    if (isPartner) {
      return Variant.Default;
    }

    if (isActiveTreatment) {
      return Variant.Below;
    }

    return Variant.Default;
  },
  isDefault: variant => variant === InternetOptionVariant.Variant.Default,
  isBelow: variant => variant === InternetOptionVariant.Variant.Below,
};

export const ResultsViewVariant = {
  Variant: {
    V1: 'v1',
    V2: 'v2',
  },
  getVariant(partner, treatments) {
    const Variant = ResultsViewVariant.Variant;
    const { results_view } = treatments;

    const isPartner = !!partner?.partner_slug;
    const partnerSettings = partner?.settings || {};
    const isActiveV2View = results_view?.treatment === 'v2';

    if (isPartner && partnerSettings.fmb_results_version) {
      const partnerVersion = partnerSettings.fmb_results_version;

      return Object.values(Variant).includes(partnerVersion) ? partnerVersion : Variant.V1;
    }

    if (isActiveV2View) {
      return Variant.V2;
    }

    return Variant.V1;
  },
  isV1: variant => variant === ResultsViewVariant.Variant.V1,
  isV2: variant => variant === ResultsViewVariant.Variant.V2,
};

export const AppPurchaseTypeVariant = {
  Variant: {
    FreePaid: 'free paid',
    RentPurchase: 'rent purchase',
  },
  getVariant(app) {
    const Variant = AppPurchaseTypeVariant.Variant;
    let ResultsVariant = null;
    const { prices, price, source_type } = app;

    if (source_type) {
      const rentalCost =
        prices &&
        prices.rent &&
        !!prices.rent.reduce((acc, item) => (acc = acc || !!item.price), false);
      const purchaseCost =
        prices &&
        prices.buy &&
        !!prices.buy.reduce((acc, item) => (acc = acc || !!item.price), false);
      const hasAnyCost = rentalCost || purchaseCost;

      // type is free
      // or
      // has price and hasn't any cost
      if (source_type.type === 0 || (price && !hasAnyCost)) {
        ResultsVariant = Variant.FreePaid;
      }

      // hasn't price and has any cost
      if (!price && hasAnyCost) {
        ResultsVariant = Variant.RentPurchase;
      }

      // type is store
      if (source_type.type === 3) {
        ResultsVariant = Variant.RentPurchase;
      }

      // fallback
      if (!ResultsVariant) {
        ResultsVariant = Variant.FreePaid;
      }
    } else {
      ResultsVariant = Variant.FreePaid;
    }

    return ResultsVariant;
  },
  isFreePaid: variant => variant === AppPurchaseTypeVariant.Variant.FreePaid,
  isRentPurchase: variant => variant === AppPurchaseTypeVariant.Variant.RentPurchase,
};

export const SubscriptionBtnNameVariant = {
  Variant: {
    signUp: 'signUp',
    buyNow: 'buyNow',
    subscribe: 'subscribe',
  },
  getVariant(treatments) {
    const Variant = SubscriptionBtnNameVariant.Variant;
    const { subscription_btn_name } = treatments;
    const splitVariant = subscription_btn_name?.treatment || '';

    if (splitVariant) {
      return Object.values(Variant).includes(splitVariant) ? splitVariant : Variant.subscribe;
    }

    return Variant.subscribe;
  },
};

export const LearnMoreBtnNameVariant = {
  Variant: {
    select: 'select',
    learnMore: 'learnMore',
  },
  getVariant(treatments) {
    const Variant = LearnMoreBtnNameVariant.Variant;
    const { results_bundle_learn_more_btn_name } = treatments;
    const splitVariant = results_bundle_learn_more_btn_name?.treatment || '';

    if (splitVariant) {
      return Object.values(Variant).includes(splitVariant) ? splitVariant : Variant.learnMore;
    }

    return Variant.learnMore;
  },
};

export const FMBChangeFlowVariant = {
  Variant: {
    regular: 'regular',
    newOrder: 'newOrder',
  },
  getVariant(treatments) {
    const Variant = FMBChangeFlowVariant.Variant;
    const { fmb_change_flow } = treatments;
    const splitVariant = fmb_change_flow?.treatment || '';

    if (splitVariant) {
      return Object.values(Variant).includes(splitVariant) ? splitVariant : Variant.regular;
    }

    return Variant.regular;
  },
};

export const SingleBundleViewVariant = {
  Variant: {
    on: 'on',
    off: 'off',
  },
  getVariant(treatments) {
    const Variant = SingleBundleViewVariant.Variant;
    const { results_single_bundle_view } = treatments;
    const splitVariant = results_single_bundle_view?.treatment || '';

    if (splitVariant) {
      return Object.values(Variant).includes(splitVariant) ? splitVariant : Variant.off;
    }

    return Variant.off;
  },
};

export const BundleMainAction = {
  Variant: {
    link: 'link',
    modal: 'modal',
  },
  getVariant(treatments) {
    const Variant = BundleMainAction.Variant;
    const { results_bundle_main_action } = treatments;
    const splitVariant = results_bundle_main_action?.treatment || '';

    if (splitVariant) {
      return Object.values(Variant).includes(splitVariant) ? splitVariant : Variant.modal;
    }

    return Variant.modal;
  },
};

export const FMBOnePageView = {
  Variant: {
    on: 'on',
    off: 'off',
  },
  getVariant(treatments) {
    const Variant = FMBOnePageView.Variant;
    const { fmb_one_page_view } = treatments;
    const splitVariant = fmb_one_page_view?.treatment || '';

    if (splitVariant) {
      return Object.values(Variant).includes(splitVariant) ? splitVariant : Variant.off;
    }

    return Variant.off;
  },
};

export const BlackFridayBannerPosition = {
  Variant: {
    first: 'first',
    second: 'second',
  },
  getVariant(treatments) {
    const Variant = BlackFridayBannerPosition.Variant;
    const { black_friday_banner_position } = treatments;
    const splitVariant = black_friday_banner_position?.treatment || '';

    if (splitVariant) {
      return Object.values(Variant).includes(splitVariant) ? splitVariant : Variant.first;
    }

    return Variant.first;
  },
};
